var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../di";
import { t, translate } from "../I18n";
import { TemporarilyUnavailableLabel } from "./TemporarilyUnavailableLabel";
import { FulfillmentTimeScope } from "../ordering";
let OrderForLabel = class OrderForLabel {
    constructor(fulfillmentTimeScope, temporarilyUnavailableLabel) {
        this.fulfillmentTimeScope = fulfillmentTimeScope;
        this.temporarilyUnavailableLabel = temporarilyUnavailableLabel;
        makeAutoObservable(this);
    }
    label(unavailabilityReasons, preorderSettings) {
        if (this.fulfillmentTimeScope.fulfillmentTime === null ||
            this.temporarilyUnavailableLabel.shouldAppear(unavailabilityReasons) ||
            !unavailabilityReasons.includes("Preorder")) {
            return null;
        }
        const { onlyRange, isSameDayOnly } = preorderSettings;
        if (onlyRange === null || isSameDayOnly) {
            return null;
        }
        const begin = onlyRange.begin.formatDDMM();
        const end = onlyRange.end.formatDDMM();
        const message = begin === end
            ? translate(t.client.labels.not_available_now.order_for_exact_date, {
                begin,
            })
            : translate(t.client.labels.not_available_now.order_for, {
                begin,
                end,
            });
        return {
            message,
            enabledOnClick: true,
            type: "info",
        };
    }
};
OrderForLabel = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof FulfillmentTimeScope !== "undefined" && FulfillmentTimeScope) === "function" ? _a : Object, typeof (_b = typeof TemporarilyUnavailableLabel !== "undefined" && TemporarilyUnavailableLabel) === "function" ? _b : Object])
], OrderForLabel);
export { OrderForLabel };
